import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckIcon, DownloadIcon, Trash2Icon } from 'lucide-react';
import { Avatar } from '../../components/Avatar';
import { PageHeader } from '../../components/PageHeader';
import { SettingsGroup, SettingsRow } from '../../components/SettingsList';
import { Card, SectionTitle } from '../../components/ui/Card';
import { people } from '../../data/people';
import { useLocale } from '../../contexts/LocaleContext';
import { useMetrics } from '../../contexts/MetricsContext';
export function Account() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    profile
  } = useMetrics();
  return <div className="px-2 pb-2" data-id="element-3690" data-mp="1mvd4fb6pdult">
      <PageHeader title={t('settings.account')} showBack data-id="element-3691" data-mp="1rs3g7mbh641f" />

      <Card className="p-2" data-id="element-3692" data-mp="1rsmy5314ksfg">
        <div className="flex items-center gap-2" data-id="element-3693" data-mp="3h7baj49puadh">
          <Avatar src={people[0].avatar} name={profile.name} size={60} data-id="element-3694" data-mp="3h7uk9xp7psgf" />
          <div className="min-w-0 flex-1" data-id="element-3695" data-mp="3m6o0vyzspzkt">
            <p className="truncate text-[15px] font-bold text-deep" data-id="element-3696" data-mp="3m4bjpo1v3t8t">
              {profile.name}
            </p>
            <p className="truncate text-[12px] text-muted" data-id="element-3697" data-mp="1c12v5wjfzy91">{profile.username}</p>
            <p className="mt-1 flex items-center gap-1 text-[11px] font-medium text-gold-deep" data-id="element-3698" data-mp="181loizsa4v2a">
              <CheckIcon size={12} strokeWidth={3} aria-hidden="true" data-id="element-3699" data-mp="1lsgy6ealrg6x" />
              {t('account.statusActive')}
            </p>
          </div>
        </div>
      </Card>

      <div className="mt-3" data-id="element-3700" data-mp="t5mgfp566ux5">
        <SectionTitle data-id="element-3701" data-mp="t4uwjbkxqlmp">{t('account.data')}</SectionTitle>
        <SettingsGroup data-id="element-3702" data-mp="p3rj0vqd11on">
          <SettingsRow label={t('profile.field.name')} value={profile.name} onClick={() => navigate('/perfil/editar')} data-id="element-3703" data-mp="p4kfn3vluat2" />
          <SettingsRow label={t('profile.field.username')} value={profile.username} onClick={() => navigate('/perfil/editar')} data-id="element-3704" data-mp="y34prgn3nc5o" />
          <SettingsRow label={t('account.email')} value="ana@beelyv.com" data-id="element-3705" data-mp="29iteodjwyl94" />
          <SettingsRow label={t('account.birth')} value="14/03/1992" data-id="element-3706" data-mp="29kxhst9zng8c" />
          <SettingsRow label={t('profile.photo')} hint={t('profile.photoHint')} onClick={() => navigate('/perfil/editar')} data-id="element-3707" data-mp="2hir1b6r2r5c3" />
        </SettingsGroup>
      </div>

      <div className="mt-3" data-id="element-3708" data-mp="2qlidj8rry54s">
        <SectionTitle data-id="element-3709" data-mp="2qie51z7a0n8b">{t('account.management')}</SectionTitle>
        <SettingsGroup data-id="element-3710" data-mp="2vhz5ke23h3n5">
          <SettingsRow label={t('account.export')} hint={t('account.exportHint')} icon={<DownloadIcon size={17} data-id="element-3712" data-mp="1xtoz9mv9ztq8" />} onClick={() => navigate('/config/dados')} data-id="element-3711" data-mp="2viikrn0d1dxh" />
          <SettingsRow label={t('settings.delete')} hint={t('settings.deleteHint')} icon={<Trash2Icon size={17} data-id="element-3714" data-mp="2ck629ank6rp8" />} tone="danger" onClick={() => navigate('/config/excluir')} data-id="element-3713" data-mp="22sa4y1tar5m2" />
        </SettingsGroup>
      </div>
    </div>;
}